// tile-frames/index.js
// Exports all type-specific frame components.
// ProjectTileFrame uses `if:` conditions to gate which frame renders
// based on s.projectType — no helper needed at import time.

export { AppFrame } from './AppFrame.js'
export { DeckFrame } from './DeckFrame.js'
export { MobileFrame } from './MobileFrame.js'
export { DesktopFrame } from './DesktopFrame.js'
export { TVFrame } from './TVFrame.js'
export { LibraryFrame } from './LibraryFrame.js'
export { PlatformFrame } from './PlatformFrame.js'
